<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <th v-show="editMode" width="20"></th>
                        <th v-show="editMode" width="20">EDIT</th>
                        <th> KANABAKARI </th>
                        <th> HOUSE TYPE </th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,i) in KANABAKARI_SETTINGS" :key="i">
                        <td v-show="editMode">
                            <v-checkbox v-model="item.selected" dense></v-checkbox>
                        </td>
                        <td v-show="editMode">
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </td>
                        <td> {{ item.kanabakari_name }} </td>
                        <td>
                            <v-chip class="mx-1 font-weight-bold" small v-for="(SUBITEM, ii) in item.kanahousetype" :key="`${i}-${ii}`">
                                {{ SUBITEM.kanabakari_house }}
                            </v-chip>
                        </td>
                        <td v-show="viewMode"> {{ formatDate(item.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(item.updated_at) }} </td>
                        <td v-show="viewMode"> {{ item.created_by }} </td>
                        <td v-show="viewMode"> {{ item.updated_by }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <!-- mainTable End -->
        </v-container>

        <!-- Dialogs -->
        <!-- Dialog Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title>
                        <span class="overline">Create Kanabakari Settings</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                            <v-autocomplete
                                    :items="kanabakari"
                                    item-value="value"
                                    item-text="text"
                                    outlined 
                                    label="Kanabakari"
                                    name="kanabakari_name" 
                                    class="required"
                                    :rules="rules.required"> 
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    :items="HOUSE_TYPES"
                                    item-value="id"
                                    item-text="name"
                                    outlined 
                                    multiple 
                                    label="House Type"
                                    name="house_type_id" 
                                    class="required"
                                    :rules="rules.required"
                                    chips
                                    small-chips
                                    deletable-chips> 
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Start -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit Kanabakari Counter</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete 
                                        v-model="tempData.kanabakari_name"
                                        :items="kanabakari"
                                        item-text="text"
                                        item-value="value"
                                        outlined 
                                        dense 
                                        label="Kanabakari"
                                        name="kanabakari_name" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="tempData.house_type_id"
                                        :items="HOUSE_TYPES"
                                        item-value="id"
                                        item-text="name"
                                        outlined 
                                        multiple 
                                        label="House Type"
                                        name="house_type_id" 
                                        class="required"
                                        :rules="rules.required"
                                        chips
                                        small-chips
                                        deletable-chips> 
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer :items="KANABAKARI_SETTINGS.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
    export default {
        components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'KANABAKARI (矩計)',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            kanabakari : [
                {text : '240', value : '240'},
                {text : '260+', value : '260+'},
                {text : '265', value : '265'}
            ],

            floatButtons:{
                add: true,
                update: true,
                delete: true
            },

            tempData: {},
            
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,

        }),

        computed : {
            ...mapState([
                'KANABAKARI_SETTINGS',
                'HOUSE_TYPES',
                'rules',
                'viewMode',
                'editMode'
            ]),

            selectedData(){
                // this will return only the id of the selected data
                return this.KANABAKARI_SETTINGS.filter(res => res.selected).map(res => res.id); 
            }
        },

        methods: {
            ...mapActions([
                '_getKanabakari',
                '_getHouseTypes',
            ]),

            toggleDialogDelete(val){
                console.log(val)
                this.dialogDelete = val;
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/kanabakari_settings/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getKanabakari();
                    this.dialogDelete = false;
                })
            },

            toggleUpdateDialog(item){
                console.log(item)
                if(item){
                    this.tempData = {...item};
                    this.tempData.house_type_id = this.tempData.kanahousetype.map(res => parseInt(res.house_type_id))
                    // console.log(this.tempData.house_type_id)
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Update(){
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/kanabakari_settings/update/${id}`,
                        data: formdata
                    }).then(() => {
                        this._getKanabakari();
                        this.$refs.Update.resetValidation();
                        this.$refs.Update.reset();
                        this.dialogUpdate = false;
                    })
                }
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);

                    axios({
                        method: 'POST',
                        url: '/api/kanabakari_settings/store',
                        data: formdata
                    }).then(() => {
                        this._getKanabakari();
                        this.$refs.Store.resetValidation();
                        this.$refs.Store.reset();
                        this.dialogStore = false;
                    })
                }
            },

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            toggleDialogStore(val){
                this.dialogStore = val;
            },

            
        },

        mounted() {
            this._getKanabakari().then(() => {
                this._getHouseTypes();
            })
        },
    }
</script>

<style scoped>
</style>